import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from "react-router-dom"
import {
	Row,
	Col,
	Spinner
} from "react-bootstrap";
import PerformanceLoader from '../../../jsx/components/PerformanceLoader'

//Import Components
import ArchiveChartCard16Sat from '../../pages/PerformanceScoreNewUI/performanceComponent/ArchiveChartCard16Sat';
import ArchiveChartCard16Mat from '../../pages/PerformanceScoreNewUI/performanceComponent/ArchiveChartCard16Mat';
import ChartCard20 from '../../pages/PerformanceScoreNewUI/performanceComponent/ChartCard20';
import ChartCard21 from '../../pages/PerformanceScoreNewUI/performanceComponent/ChartCard21';

import setBodyImage from '../../../setBodyImage';
import dashboardBackground from '../../../images/light_background_1.png'
import performerBackground from '../../../images/score_2background.png'

import { getCompetitiveSetwiseSatScoreDataDetails, getCompetitiveSetwiseMatScoreDataDetails, performanceRequestAction, getCompetitiveSetwiseSatScoreSubjectDataDetails, getCompetitiveSetwiseMatScoreSubjecttDataDetails } from '../../../store/actions/ArchivePerformanceScoreAction';

const ArchiveSubjectwiseCompetitiveScore = (props) => {

	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();

	const [previousValue, setPrevousValue] = useState(location.state)

	const [typeName, setTypeName] = useState('')
	const [pageName, setpageName] = useState('')

	useEffect(() => {
		const pathName = window.location.pathname.split('/');
		const id_path = pathName[2];
		const com_type = id_path.split('-');
		const name_com_type = com_type[1];
		setTypeName(name_com_type);
		setpageName(com_type.join(" "))

		dispatch(performanceRequestAction(true))
		dispatch(getCompetitiveSetwiseSatScoreDataDetails(location.state.set_no, location.state.exam_type,location.state.class_no, props.history))
		dispatch(getCompetitiveSetwiseMatScoreDataDetails(location.state.set_no, location.state.exam_type,location.state.class_no, props.history))

		dispatch(getCompetitiveSetwiseSatScoreSubjectDataDetails(location.state.set_no, location.state.exam_type,location.state.class_no, props.history))
		dispatch(getCompetitiveSetwiseMatScoreSubjecttDataDetails(location.state.set_no, location.state.exam_type,location.state.class_no, props.history))

		if (location.state.exam_type == 'undefined' || location.state.exam_type == undefined) {
			history.push({ pathname: "/PerformanceCategoryPage" })
		}

		setBodyImage(performerBackground)

		return () => {
			setBodyImage(dashboardBackground)
		};

	}, []);

	useEffect(() => {


	}, [props.getcompetitiveSetwiseSatScore, props.competitiveSetwiseSatScoreSubject, props.competitiveSetwiseMatScoreSubject]);


	const goPrevious = () => {
		history.goBack()
	}



	return (
		<>
			<div className="row">
				<div className="col-md-12 mb-3">
					<div className='text_blue'>Archive Performance Score <i className="bi bi-chevron-right"></i> Archive Competitive Performance Score <i className="bi bi-chevron-right"></i> {location.state.page_name}<i className="bi bi-chevron-right"></i> {pageName}</div>
				</div>
			</div>

			<div className="row">
				<div className="col-md-1">
					<div className="top_back_container" onClick={goPrevious}>
						<span className="back_arrow"><i className="bi bi-chevron-left"></i></span>
						Back
					</div>
				</div>
			</div>
			<Row>
				<Col xl={6}>
					{props.getcompetitiveSetwiseSatScore != '' && props.getcompetitiveSetwiseSatScore != undefined ?
						<ArchiveChartCard16Sat
							pageHeading={typeName == "NTSE" ? "Grade Grid - Set (SAT)" : "Set Wise Score"}
							dataSet={props.getcompetitiveSetwiseSatScore}
							setNumber={previousValue.set_no}
							exam_type={previousValue.exam_type}
							typeName={typeName}
							subType="SAT"
							previousPageName={pageName}
							parentpreviousPageName={location.state.page_name}
							classNo={location.state.class_no}
						/>
						:
						<PerformanceLoader />
					}
				</Col>

				<Col xl={6}>
					{props.competitiveSetwiseSatScoreSubject != '' && props.competitiveSetwiseSatScoreSubject != undefined ?
						<ChartCard20
							pageHeading="Subject Analysis - Set"
							dataSet={props.competitiveSetwiseSatScoreSubject}
							setNumber={previousValue.set_no}
							typeName={typeName}
						/>
						:
						<PerformanceLoader />
					}
				</Col>
				{typeName == "NTSE" ?
					<>
						<Col xl={6}>
							{props.getcompetitiveSwiseMatScore != '' && props.getcompetitiveSwiseMatScore != undefined ?
								<ArchiveChartCard16Mat
									// pageHeading="Set Wise MAT Score" 
									pageHeading="Grade Grid - Set (MAT)"
									dataSet={props.getcompetitiveSwiseMatScore}
									setNumber={previousValue.set_no}
									exam_type={previousValue.exam_type}
									typeName={typeName}
									subType="MAT"
									previousPageName={pageName}
									classNo={location.state.class_no}
									parentpreviousPageName={location.state.page_name}
								/>
								:
								<PerformanceLoader />
							}
						</Col>
						<Col xl={6}>
							{props.competitiveSetwiseMatScoreSubject != '' && props.competitiveSetwiseMatScoreSubject != undefined ?
								<ChartCard21
									pageHeading="Subject Analysis - Set"
									dataSet={props.competitiveSetwiseMatScoreSubject}
									setNumber={previousValue.set_no}
									typeName={typeName}
								/>
								:
								<PerformanceLoader />
							}
						</Col>
					</>
					: null}

			</Row>

		</>
	)
}

const mapStateToProps = (state) => {

	return {
		loading: state.performance.loading,
		getcompetitiveSetwiseSatScore: state.archivePerformance.getcompetitiveSetwiseSatScore,
		getcompetitiveSwiseMatScore: state.archivePerformance.getcompetitiveSwiseMatScore,
		competitiveSetwiseSatScoreSubject: state.archivePerformance.competitiveSetwiseSatScoreSubject,
		competitiveSetwiseMatScoreSubject: state.archivePerformance.competitiveSetwiseMatScoreSubject,
	};
};
export default connect(mapStateToProps)(ArchiveSubjectwiseCompetitiveScore);